import { render, staticRenderFns } from "./FaceRecord.vue?vue&type=template&id=36635708&scoped=true&"
import script from "./FaceRecord.vue?vue&type=script&lang=ts&"
export * from "./FaceRecord.vue?vue&type=script&lang=ts&"
import style0 from "./FaceRecord.vue?vue&type=style&index=0&id=36635708&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36635708",
  null
  
)

export default component.exports